<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Je Komponenteninstanz eigener Timer und eigene Anfragefolge.
    this.timeout = null;
    this.querySeq = 0;
    this.isTornDown = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.isTornDown = true;
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val) {
        this.invalidate();
        if (!this.select) {
          this.items = [];
        }
        return;
      }

      // Kein erneuter Abruf für den Text der aktuellen Auswahl (Objekt oder per v-model gesetzter Text).
      const selectedText = typeof this.select === "string"
        ? this.select
        : (this.select && this.select.text);
      if (selectedText && val === selectedText) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage; verspätete Antworten werden verworfen.
    invalidate() {
      this.querySeq++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.invalidate();

      const seq = this.querySeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoderReady.then(geocoder => {
          if (seq !== this.querySeq || this.isTornDown) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (seq !== this.querySeq || this.isTornDown) {
            return;
          }
          if (items !== null) {
            this.items = items.slice();
          }
          this.loading = false;
        }, () => {
          if (seq !== this.querySeq || this.isTornDown) {
            return;
          }
          this.items = [];
          this.loading = false;
        });
      }, 150);
    },

    change(o) {
      this.invalidate();
      this.items = o ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
